var map = {
	"./arrowdown.png": 197,
	"./arrowlinedown.png": 7015,
	"./arrowlineup.png": 2588,
	"./arrowright.png": 7643,
	"./icons/democratic-discussion.png": 791,
	"./icons/discussion.png": 5681,
	"./icons/fossil-free.png": 2806,
	"./icons/fossil-ties.png": 9381,
	"./icons/intransparent.png": 2596,
	"./icons/no-discussion.png": 7571,
	"./icons/no-fossil-policy.png": 2643,
	"./icons/no-no-fossil-policy.png": 8738,
	"./icons/no-sustainability-policy.png": 8557,
	"./icons/progress.png": 9832,
	"./icons/sustainability-policy.png": 4199,
	"./icons/transparent.png": 7779,
	"./icons/unknown-fossil.png": 3018,
	"./icons/unknown-transparent.png": 838,
	"./icons/unknown.png": 7247,
	"./logo_thumbs/URTUE.png": 5613,
	"./logo_thumbs/boing.png": 2855,
	"./logo_thumbs/logo_EFO.png": 7178,
	"./logo_thumbs/logo_EFO_large.png": 7450,
	"./logo_thumbs/logo_MD.png": 2915,
	"./logo_thumbs/logo_MDJ.png": 1457,
	"./logo_thumbs/logo_STPC.png": 2786,
	"./logo_thumbs/logo_UR.png": 6493,
	"./logo_thumbs/logo_aria.png": 4007,
	"./logo_thumbs/logo_fv.png": 8840,
	"./logo_thumbs/logo_mj.png": 8445,
	"./logo_thumbs/logo_orca.png": 1419,
	"./logo_thumbs/logo_s4f.png": 11,
	"./logo_thumbs/logo_sr.png": 9679,
	"./logo_thumbs/logo_ssr.png": 6678,
	"./logo_thumbs/minor-foundation-logo-black.png": 675,
	"./logo_thumbs/minor-foundation-logo-white.png": 2765,
	"./obsolete/activist.png": 5133,
	"./obsolete/arrowdownold.png": 236,
	"./obsolete/arrowlinedownempty.png": 362,
	"./obsolete/arrowrightold.png": 6274,
	"./obsolete/bigdot.png": 5461,
	"./obsolete/blue.png": 4242,
	"./obsolete/bluegrey.png": 2455,
	"./obsolete/blueyellow.png": 6686,
	"./obsolete/convo_blue.png": 9130,
	"./obsolete/convo_bluegrey.png": 3663,
	"./obsolete/convo_grey.png": 9435,
	"./obsolete/fair_blue.png": 3529,
	"./obsolete/fair_bluegrey.png": 4424,
	"./obsolete/fair_blueyellow.png": 6473,
	"./obsolete/fair_grey.png": 2504,
	"./obsolete/fair_greyyellow.png": 9068,
	"./obsolete/fair_yellow.png": 7641,
	"./obsolete/grey.png": 8963,
	"./obsolete/greyyellow.png": 4339,
	"./obsolete/money_blue.png": 6569,
	"./obsolete/money_bluegrey.png": 6536,
	"./obsolete/money_blueyellow.png": 1017,
	"./obsolete/money_grey.png": 7064,
	"./obsolete/money_greyyellow.png": 6047,
	"./obsolete/news.png": 2391,
	"./obsolete/policy_blue.png": 3461,
	"./obsolete/policy_bluegrey.png": 7716,
	"./obsolete/policy_blueyellow.png": 5146,
	"./obsolete/policy_grey.png": 5836,
	"./obsolete/policy_greyyellow.png": 5640,
	"./obsolete/prof_blue.png": 8132,
	"./obsolete/prof_bluegrey.png": 7313,
	"./obsolete/prof_blueyellow.png": 7600,
	"./obsolete/prof_grey.png": 3761,
	"./obsolete/prof_greyyellow.png": 5553,
	"./obsolete/smalldot.png": 7516,
	"./obsolete/yellow.png": 8418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;